import { render } from "./ManagerCustomerChat.vue?vue&type=template&id=758f112b&scoped=true"
import script from "./ManagerCustomerChat.vue?vue&type=script&lang=js"
export * from "./ManagerCustomerChat.vue?vue&type=script&lang=js"

import "./ManagerCustomerChat.vue?vue&type=style&index=0&id=758f112b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-758f112b"]])

export default __exports__